import { BucketServiceFileItemDto } from '@nimbus/bucket-service/lib/api';

export interface BucketAttachment {
  bucket: {
    globalId: string;
    userId: number;
    workspaceId: string;
    target: string;
    targetId: string;
    groupId: string;
    activeItems: number;
    clock: number;
    deleted: boolean;
  };
  attachment: {
    globalId: string;
    bucketId: string;
    userId: number;
    workspaceId: string;
    storedFileUUID: string;
    filename: string;
    type: string;
    kind: string;
    size: number;
    extra: {
      height: number;
      width: number;
      type: string;
    };
    clock: number;
    deleted: boolean;
    createdAt: number;
    updatedAt: number;
  };
  file: BucketServiceFileItemDto;
}

/**
 *
 * @export
 * @interface BucketServiceAttachmentDto
 */
export interface BucketServiceAttachmentDto {
  /**
   *
   * @type {string}
   * @memberof BucketServiceAttachmentDto
   */
  globalId: string;
  /**
   *
   * @type {string}
   * @memberof BucketServiceAttachmentDto
   */
  bucketId: string;
  /**
   *
   * @type {number}
   * @memberof BucketServiceAttachmentDto
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof BucketServiceAttachmentDto
   */
  workspaceId: string;
  /**
   *
   * @type {string}
   * @memberof BucketServiceAttachmentDto
   */
  filename: string;
  /**
   *
   * @type {string}
   * @memberof BucketServiceAttachmentDto
   */
  storedFileUUID: string;
  /**
   *
   * @type {BucketServiceAttachmentKindDto}
   * @memberof BucketServiceAttachmentDto
   */
  kind: BucketServiceAttachmentKindDto;
  /**
   *
   * @type {string}
   * @memberof BucketServiceAttachmentDto
   */
  type: string;
  /**
   *
   * @type {number}
   * @memberof BucketServiceAttachmentDto
   */
  size: number;
  /**
   *
   * @type {object}
   * @memberof BucketServiceAttachmentDto
   */
  extra: object;
  /**
   *
   * @type {number}
   * @memberof BucketServiceAttachmentDto
   */
  clock: number;
  /**
   *
   * @type {boolean}
   * @memberof BucketServiceAttachmentDto
   */
  deleted: boolean;
  /**
   *
   * @type {number}
   * @memberof BucketServiceAttachmentDto
   */
  updatedAt?: number;
  /**
   *
   * @type {number}
   * @memberof BucketServiceAttachmentDto
   */
  createdAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof BucketServiceAttachmentDto
   */
  noteServiceAttachment?: boolean;
}

export const BucketServiceAttachmentKindDto = {
  File: 'file',
  Image: 'image',
  Video: 'video',
  Audio: 'audio',
  Doc: 'doc',
  Archive: 'archive',
} as const;

export type BucketServiceAttachmentKindDto =
  (typeof BucketServiceAttachmentKindDto)[keyof typeof BucketServiceAttachmentKindDto];
